module.exports = __webpack_public_path__ + "img/skinner-1-l.6d480b10.png";